import React from 'react';
import styled from 'styled-components';

interface Props {
    children?: React.ReactNode;
}

export const ScreenReaderOnly = ({ children }: Props) => <SrOnly>{children}</SrOnly>;

// https://webaim.org/techniques/css/invisiblecontent/
const SrOnly = styled.div`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
`;
